// extracted by mini-css-extract-plugin
module.exports = {"container":"ordersummary_container__3zY6x","sumRow":"ordersummary_sumRow__1uO_r","sumLabel":"ordersummary_sumLabel__g63xQ","sumItem":"ordersummary_sumItem__aNUm0"};